import {
    SET_SUMMARY,
    SET_ALLOW_ORDER_EDIT,
    SET_SUBSCRIPTION_NEXT_DELIVERY_DATE,
    SET_PICKUP_SITES_DELIVERY_DATE,
    SET_PICKUP_SITE,
    SET_WAIT_LIST_PICKUP_SITE,
    SET_PAYMENT_PLAN,
    SET_PAYMENT_METHOD,
    SET_PAYMENT_TYPE,
    SET_VACATIONS,
    SET_PICKUP_SITES_DELIVERY_DATE_ACTUAL,
    SET_CAN_SAVE_DELIVERY_HOLD,
    SET_CUSTOM_AMOUNT,
    SET_ALLOW_CONTINUE_PAYMENT,
    SET_WEB_ORDER,
    SET_CREATEING_SUBSCRIPTION,
    SET_MULTI_ORDER_EDIT,
    SET_ON_PERMANENT_HOLD,
    SET_REQUIRED_MAKE_UP_DATA
} from '../../actions/actionTypes';

export function summaryReducer(state, action) {
	state = state || {};
	switch (action.type) {
        case SET_SUMMARY:
            return Object.assign({}, state, action.summary);
        case SET_ALLOW_ORDER_EDIT:
            return Object.assign({}, state, {allowOrderEdit: action.allowOrderEdit});
        case SET_MULTI_ORDER_EDIT:
            return Object.assign({}, state, {editMultiOrder: action.editMultiOrder});
        case SET_SUBSCRIPTION_NEXT_DELIVERY_DATE:
            return Object.assign({}, state, {nextDeliveryDate: action.nextDeliveryDate});
        case SET_PICKUP_SITES_DELIVERY_DATE:
            return Object.assign({}, state, {
                pickupSite: action.pickupSite,
                waitListSite: action.waitListSite,
                nextDeliveryDate: action.nextDeliveryDate
            });
        case SET_PICKUP_SITES_DELIVERY_DATE_ACTUAL:
            return Object.assign({}, state, {
                pickupSite: action.pickupSite,
                nextDeliveryDate: action.nextDeliveryDate
            });
        case SET_PICKUP_SITE:
            return Object.assign({}, state, {
                pickupSite: action.pickupSite
            });
        case SET_WAIT_LIST_PICKUP_SITE:
            return Object.assign({}, state, {
                waitListSite: action.waitListSite
            });
        case SET_CAN_SAVE_DELIVERY_HOLD:
            return Object.assign({}, state, {
                canSaveDeliveryHold: action.canSaveDeliveryHold
            });
        case SET_PAYMENT_PLAN: {
            let obj = {};
            obj[action.paymentType + "PaymentPlan"] = action.paymentPlan;
            return Object.assign({}, state, obj);
        }
        case SET_PAYMENT_METHOD: {
            let obj = {};
            obj[action.paymentType + "PaymentMethod"] = action.paymentMethod;
            return Object.assign({}, state, obj);
        }
        case SET_PAYMENT_TYPE:
            return Object.assign({}, state, {paymentType: action.paymentType});
        case SET_CUSTOM_AMOUNT:
            return Object.assign({}, state, {customAmount: action.customAmount});
        case SET_ALLOW_CONTINUE_PAYMENT:
            return Object.assign({}, state, {allowContinuePayment: action.allowContinuePayment});
        case SET_VACATIONS:
            return Object.assign({}, state, {
                vacationEnd: action.vacationEnd,
                vacationStart: action.vacationStart
            });
        case SET_REQUIRED_MAKE_UP_DATA:
            return Object.assign({}, state, {
                requiredMakeUpData: action.requiredMakeUpData
            });
        case SET_WEB_ORDER:
            return Object.assign({}, state, {
                activeWebOrderKey: action.webOrderKey
            });
        case SET_CREATEING_SUBSCRIPTION:
            return Object.assign({}, state, {
                isCreatingSubscription: action.isCreatingSubscription
            });
        case SET_ON_PERMANENT_HOLD:
            return Object.assign({}, state, {
                isSetOnPermanentHold : action.isSetOnPermanentHold
            });
        default:
			return state;
	}
}


// WEBPACK FOOTER //
// ./src/reducers/common/summaryReducer.js